<div class="text-divider">
  <div class="text-divider__line"></div>
  <div class="text-divider__text">
    <ng-content></ng-content>
  </div>

  <div class="text-divider__line"></div>
</div>
